/** This enumeration defines the types of gift cards */
export enum GiftCardTypeEnum {
    Virtual = 'VIRTUAL',
    Physical = 'PHYSICAL',
    Combined = 'COMBINED'
}
